// Module
var code = " <gh-no-entry *ngIf=\"isEmpty\" size=\"300px\" class=\"no-entry-large\" label=\"{{'lbl_you_have_no_entries' | translate}}\"></gh-no-entry> <ng-content></ng-content>";
// Exports
module.exports = code;